export default {
  dataIterator: {
    rowsPerPageText: 'Itens por página:',
    rowsPerPageAll: 'Todos',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Nenhum resultado encontrado',
    nextPage: 'Próxima página',
    prevPage: 'Página anterior'
  },
  dataTable: {
    rowsPerPageText: 'Linhas por página:',
    noDataText: 'Nenhum dado disponível',
    sortBy: 'Ordenar por'
  },
  noDataText: 'Nenhum registro encontrado',
  carousel: {
    prev: 'Visual anterior',
    next: 'Próximo visual'
  },
  calendar: {
    moreEvents: 'Mais {0}'
  },
  // Novas chaves adicionadas
  datePicker: {
    itemsSelected: '{0} selecionado(s)',
    nextMonthAriaLabel: 'Próximo mês',
    nextYearAriaLabel: 'Próximo ano',
    prevMonthAriaLabel: 'Mês anterior',
    prevYearAriaLabel: 'Ano anterior'
  },
  pagination: {
    ariaLabel: 'Navegação de paginação',
    firstPage: 'Primeira página',
    lastPage: 'Última página',
    nextPage: 'Próxima página',
    prevPage: 'Página anterior',
    page: 'Página',
    currentPage: 'Página atual'
  },
  rating: {
    ariaLabel: {
      item: 'Avaliação {0} de {1}'
    }
  },
  loading: 'Carregando...',
  breadcrumbs: {
    divider: '/'
  },
  badge: {
    dot: 'Ponto',
    icon: 'Ícone'
  },
  chip: {
    close: 'Fechar'
  },
  alert: {
    close: 'Fechar alerta'
  },
  combobox: {
    noDataText: 'Nenhum dado disponível'
  },
  select: {
    noDataText: 'Nenhum dado disponível',
    itemsSelected: '{0} item(s) selecionado(s)'
  },
  fileInput: {
    counter: '{0} arquivo(s)',
    counterSize: '{0} arquivo(s) ({1} no total)'
  },
  timePicker: {
    am: 'AM',
    pm: 'PM'
  },
  dataFooter: {
    itemsPerPageText: 'Itens por página:',
    itemsPerPageAll: 'Todos',
    nextPage: 'Próxima página',
    prevPage: 'Página anterior',
    firstPage: 'Primeira página',
    lastPage: 'Última página',
    pageText: '{0}-{1} de {2}'
  },
  treeview: {
    label: '{0} nós'
  },
  expansionPanel: {
    expand: 'Expandir',
    collapse: 'Recolher'
  },
  stepper: {
    next: 'Próximo',
    prev: 'Anterior'
  },
  tabs: {
    next: 'Próximo',
    prev: 'Anterior'
  },
  tooltip: {
    tooltip: 'Dica'
  },
  list: {
    noAction: 'Nenhuma ação',
    selectAll: 'Selecionar todos'
  },
  menu: {
    close: 'Fechar menu'
  },
  snackbar: {
    close: 'Fechar'
  },
  itemGroup: {
    noAction: 'Nenhuma ação'
  },
  autocomplete: {
    noDataText: 'Nenhum dado disponível',
    loading: 'Carregando...'
  },
  colorPicker: {
    clear: 'Limpar',
    close: 'Fechar'
  },
  dateRange: {
    divider: 'até'
  },
  input: {
    clear: 'Limpar {0}',
    prependAction: 'Ação prévia {0}',
    appendAction: 'Ação posterior {0}'
  },
  slider: {
    thumb: {
      label: 'Controle deslizante {0}'
    }
  },
  switch: {
    input: {
      label: 'Interruptor {0}'
    }
  },
  textarea: {
    clear: 'Limpar {0}'
  },
  table: {
    ariaLabel: {
      sortDesc: 'Ordenado decrescentemente.',
      sortAsc: 'Ordenado crescentemente.',
      sortNone: 'Não ordenado.',
      activateNone: 'Ativar para remover ordenação.',
      activateDesc: 'Ativar para ordenar decrescentemente.',
      activateAsc: 'Ativar para ordenar crescentemente.'
    },
    sortBy: 'Ordenar por'
  },
  footer: {
    itemsPerPageText: 'Itens por página:',
    itemsPerPageAll: 'Todos',
    nextPage: 'Próxima página',
    prevPage: 'Página anterior',
    firstPage: 'Primeira página',
    lastPage: 'Última página',
    pageText: '{0}-{1} de {2}'
  }
}